export const resolveIpAddress = async (): Promise<string> => {
  const response = await fetch("https://api.ipify.org", { mode: "cors" });
  return response.text();
};
